<template>
  <Modal
    :darker="darker"
    :cancelText="cancelText"
    :confirmationText="confirmationText"
    :hideButtonsContainer="!showButtons"
    :hideCancelButton="hideCancelButton"
    :headerTitle="title"
    :headerIcon="
      (isError && '/assets/icons/ui/warning-outline.svg') ||
      (isSuccess && '/assets/icons/ui/checkmark-circle-outline.png')
    "
    :headerIconAlt="(isError && 'error icon') || (isSuccess && 'success icon')"
    :isAboveAll="true"
    @closeModal="$emit('closeModal')"
    @confirm="$emit('confirm')"
  >
    <template #content>
      <p class="text">{{ text }}</p>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/Utils/Modal.vue";

export default {
  name: "ModalAlert",
  props: [
    "darker",
    "hideButtonsContainer",
    "hideCancelButton",
    "isError",
    "isSuccess",
    "title",
    "text",
    "showButtons",
    "cancelText",
    "confirmationText",
  ],
  components: { Modal },
};
</script>
